import httpClient from "@/store/httpClient";

export default {
    namespaced: true,
    state: {
        filterValues: undefined,
        candidates: [],
        detailedCandidate: undefined,
    },
    mutations: {
        SET_FILTER_VALUES(state, filterValues) {
            state.filterValues = filterValues;
        },
        SET_CANDIDATES(state, candidates) {
            state.candidates = candidates;
        },
        SET_DETAILED_CANDIDATE(state, candidate) {
            state.detailedCandidate = candidate;
        }
    },
    actions: {
        async loadFilterValues({ commit }) {
            const response = await httpClient.get("/elections/filter-values");

            if(response.status === 200) {
                commit("SET_FILTER_VALUES", response.data);
            }
        },
        async loadCandidates({ commit }, filter) {
            let queryParams = new URLSearchParams();

            for (const key of Object.keys(filter)) {
                if(filter[key]) {
                    queryParams.append(key, filter[key]);
                }
            }

            let url = "/elections/candidates";
            if(Array.from(queryParams).length > 0) {
                url += `?${queryParams.toString()}`;
            }

            const response = await httpClient.get(url);

            if(response.status === 200) {
                commit("SET_CANDIDATES", response.data);
            }
        },
        async loadCandidateDetails({ commit }, { electionId, candidateId }) {
            const response = await httpClient.get(`/elections/${electionId}/candidate/${candidateId}`);

            if(response.status === 200) {
                commit("SET_DETAILED_CANDIDATE", response.data);
            }
        },
        clearDetailedCandidates({ commit }) {
            commit("SET_DETAILED_CANDIDATE", undefined);
        }
    },
    getters: {
         communeFilterValues: state => {
            const values = [{
                value: null,
                text: "Alle Kommunen"
            }];

             if(!state.filterValues?.communes && !state.filterValues?.externalCommunes) {
                return values;
            }

            if(state.filterValues?.communes) {
                values.push(...state.filterValues.communes.map(commune => ({
                    value: commune.id,
                    text: commune.name,
                })));
            }

            if(state.filterValues?.externalCommunes) {
                values.push({ header: "Weitere Kommunen" })
                values.push(...state.filterValues.externalCommunes.map(commune => ({
                    value: commune,
                    text: commune,
                })));
            }

            return values;
         },
        electionTypeFilterValues: state => {
            const values = [];

            if(!state.filterValues?.types) {
                return values;
            }

            values.push(...state.filterValues.types.map(electionType => ({
                value: electionType.id,
                text: electionType.name,
            })));

            return values;
        },
        positionFilterValues: state => {
            return ["Alle Ämter", ...(state.filterValues?.positions || [])];
        },
        candidateDetails: state => state.detailedCandidate,
        globalNote: state => {
             if(state.candidates.length === 0) {
                return null;
            }

            return state.candidates[0].election.globalNote;
        },
        getLocalNote: state => (communeId) => {
            const candidate = state.candidates.find(candidate => candidate.commune.id === communeId || candidate.commune.externalCommune === communeId);
            return candidate?.election.localNote;
        },
        electionCompleted: state => {
            if(state.candidates.length === 0) {
                return null;
            }

            return state.candidates[0].election.complete;
        },
        electionInfoUrl: state => {
            if(state.candidates.length === 0) {
                return null;
            }

            return state.candidates[0].election.infoUrl;
        },
        electionName: state => {
            if(state.candidates.length === 0) {
                return null;
            }

            return state.candidates[0].election.type;
        }
    }
}